<template>
  <ChartsListView />
</template>

<script >
// @ is an alias to /src
import ChartsListView from "@/components/ChartsListView.vue";

export default {
  name: "ChartsList",
  components: {
    ChartsListView
  }
};
</script>
